import { render } from "./AddPost.vue?vue&type=template&id=6b948ddc"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import "./AddPost.vue?vue&type=style&index=0&id=6b948ddc&lang=css"

import exportComponent from "/Users/smithy/Development/Kfzapp Development/kfzapp-idea-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__